import type { SVGProps } from 'react'
const LineFrame = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.75 4.5c-.69 0-1.25.56-1.25 1.25V7.5H3V5.75A2.755 2.755 0 0 1 5.75 3H7.5v1.5zM4.5 17v1.25c0 .69.56 1.25 1.25 1.25H7.5V21H5.75A2.755 2.755 0 0 1 3 18.25V17zm15 1.25c0 .69-.56 1.25-1.25 1.25H16.5V21h1.75A2.755 2.755 0 0 0 21 18.25V16.5h-1.5zM16.5 3h1.75A2.755 2.755 0 0 1 21 5.75V7.5h-1.5V5.75c0-.69-.56-1.25-1.25-1.25H16.5z"
			fill="currentColor"
		/>
	</svg>
)
export { LineFrame }
